import { format, isValid, parse } from 'date-fns';

import { dateFormat, dateFormatInverted } from 'constants/formats';
import { excelDateToJSDate } from 'utils/formatDate';

const EXCEL_DATE_PARSE_FORMATS = ['dd/MM/yyyy', 'dd-MM-yyyy', 'yyyy-MM-dd'];

const toDateFromExcelSerial = (serial: number): Date | null => {
  const parsed = excelDateToJSDate(serial) as Date;
  return isValid(parsed) ? parsed : null;
};

export const parseExcelDateValue = (value: unknown): Date | null => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (value instanceof Date) {
    return isValid(value) ? value : null;
  }

  if (typeof value === 'number' && !Number.isNaN(value)) {
    return toDateFromExcelSerial(value);
  }

  const stringValue = String(value).trim();
  if (!stringValue) return null;

  if (/^\d+(\.\d+)?$/.test(stringValue)) {
    const parsed = toDateFromExcelSerial(Number(stringValue));
    if (parsed) return parsed;
  }

  const parsedByFormat = EXCEL_DATE_PARSE_FORMATS.map((dateParseFormat) =>
    parse(stringValue, dateParseFormat, new Date())
  ).find((parsedDate) => isValid(parsedDate));

  if (parsedByFormat) return parsedByFormat;

  const fallback = new Date(stringValue);
  return isValid(fallback) ? fallback : null;
};

export const formatExcelDateForBulkUpload = (
  value: unknown
): string | undefined => {
  const parsed = parseExcelDateValue(value);

  if (!parsed) return undefined;

  return format(parsed, dateFormatInverted);
};

export const formatExcelDateForPreview = (value: unknown): string => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  const parsed = parseExcelDateValue(value);

  if (!parsed) return String(value);

  return format(parsed, dateFormat);
};
